"use client"

import { Skeleton } from "@/components/ui/skeleton"

const ContactStoreInfoSkeleton = () => {
    return (
        <div className="w-full flex flex-col sm:flex-row gap-0">
            {/* Left Column Skeleton */}
            <div className="w-full sm:w-[27.5%] bg-white p-6 sm:p-8 flex flex-col">
                <Skeleton className="h-8 w-32 mb-6" />
                <div className="flex flex-col gap-4 mb-6">
                    <Skeleton className="h-5 w-full" />
                    <Skeleton className="h-5 w-3/4" />
                    <Skeleton className="h-5 w-2/3" />
                    <Skeleton className="h-5 w-1/2" />
                </div>
                <Skeleton className="w-full h-px my-6" />
                <Skeleton className="h-8 w-40 mb-6" />
                <div className="flex flex-col gap-2">
                    <Skeleton className="h-5 w-full" />
                    <Skeleton className="h-5 w-full" />
                    <Skeleton className="h-5 w-full" />
                </div>
            </div>

            {/* Right Column Skeleton - Map */}
            <div className="w-full sm:w-[72.5%] h-[400px] sm:h-[600px]">
                <Skeleton className="w-full h-full" />
            </div>
        </div>
    )
}

export default ContactStoreInfoSkeleton
